var _style, _g, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNewLoader(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "loader",
    id: "Arri\\xE8re-plan_xA0_Image_1_",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1239 1239",
    style: {
      enableBackground: "new 0 0 1239 1239"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{enable-background:new    ;}\n\t.st1{fill-rule:evenodd;clip-rule:evenodd;fill:#1D1D1B;}\n\t.st2{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_1_);}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_3_1_",
    className: "st0"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_3"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M621.5,37L621.5,37c-0.1,0-0.2,0-0.3,0c-0.4,0-0.8,0-1.3,0l0,0c-37.7,0.8-67.9,31.6-67.9,69.5 c0,38.4,31.1,69.5,69.5,69.5c246.1,0,445.6,199.5,445.6,445.5s-199.5,445.5-445.6,445.5c-131.2,0-249.1-56.7-330.7-146.9 l-106.7,87.1C290.9,1127.4,446.6,1203,619.9,1203c322,0,583.1-261,583.1-583C1203,298.5,942.8,37.9,621.5,37z"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_3_-_copie",
    className: "st0"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_3_4_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 54.8292,
    y1: 609.6421,
    x2: 259.344,
    y2: 963.8723
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#1D1D1B",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6051,
    style: {
      stopColor: "#1D1D1B"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M175.9,621.6c-139.9,0-61.7,0-139-1.6c0,148.7,55.6,284.3,147.2,387.3l106.7-87.1 C219.4,841.2,175.9,736.5,175.9,621.6z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewLoader);
export default __webpack_public_path__ + "static/media/new-loader.faa1589d022e46bb39017ffbd3836094.svg";
export { ForwardRef as ReactComponent };